import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfiniteScrollDirective } from './infinite-scroll.directive';
import { LinkHelperDirective } from './link-helper.directive';
import { OnlyNumbersDirective } from './only-numbers.directive';
import { PermissionsDirective } from './permissions.directive';
import { PopupHostDirective } from './popup-host.directive';
import { OnlyNumberDecimalsDirective } from './only-number-decimals.directive';
import { ShowContentDirective } from './show-content.directive';
import { RemoveLeadingSpacesDirective } from './remove-leading-spaces.directive';
import { FeatureFlagDirective } from './feature-flag/feature-flag.directive';
import { AlphaNumericDirective } from './alpha-numeric/alpha-numeric.directive';
import { SelectOnFocusDirective } from './select-on-focus.directive';

const DIRECTIVES = [
  InfiniteScrollDirective,
  LinkHelperDirective,
  OnlyNumbersDirective,
  PermissionsDirective,
  PopupHostDirective,
  OnlyNumberDecimalsDirective,
  ShowContentDirective,
  RemoveLeadingSpacesDirective,
  FeatureFlagDirective,
  AlphaNumericDirective,
  SelectOnFocusDirective,
];

@NgModule({
  declarations: [...DIRECTIVES],
  imports: [CommonModule],
  exports: [...DIRECTIVES],
})
export class DirectiveModule {}
